module.exports = __webpack_public_path__ + "img/storm.1ca65a56.svg";